import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '18px',
  },
  formItemMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.bold,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '10px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  formScroll: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '400px',
  },
  divider: {
    marginTop: '30px',
    height: '2px',
    width: '444px',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  iconButton: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
});

export default useStyles;
